var Jwt = /** @class */ (function () {
    function Jwt() {
    }
    Jwt.parseJwt = function (token) {
        if (token === '') {
            throw "Invalid Token (missing 'userId')";
        }
        var base64Url = token.split('.')[1];
        if (base64Url === undefined) {
            throw "Invalid Token (missing 'userId')";
        }
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        var data = JSON.parse(window.atob(base64));
        if (typeof data['userId'] !== 'undefined') {
            return data;
        }
        else {
            throw "Invalid Token (missing 'userId')";
        }
    };
    return Jwt;
}());
export { Jwt };
//# sourceMappingURL=Jwt.js.map